{
  "hero": {
    "loading": "Loading content...",
    "headline": {
      "line1": "Strategic content for businesses.",
      "line2": "Efficiency and professionalism in digital marketing"
    },
    "subheadline": "Technology, design and videography come together to solve real problems",
    "primaryCta": "View projects",
    "secondaryCta": "Book a strategy session in Timișoara"
  },
  "problem": {
    "heading": "Why most digital projects fail to resonate.",
    "copy": "You hire a developer for code, a designer for a logo, and a videographer for content. The result? A fragmented brand that feels disjointed. I spent two decades seeing websites launch with great code but 'hollow' content. Khromatik was built to fix that."
  },
  "pillars": {
    "architect": {
      "title": "The Architect",
      "subtitle": "Consultancy",
      "description": "UI/UX audits and Frontend architecture for complex platforms. Senior-level expertise for big challenges."
    },
    "builder": {
      "title": "The Builder",
      "subtitle": "Development",
      "description": "Custom brand identities and high-speed websites that actually convert visitors into customers."
    },
    "storyteller": {
      "title": "The Storyteller",
      "subtitle": "Content",
      "description": "Cinematic video and photography shot on-site in Timișoara to give your tech a human soul."
    }
  },
  "holisticEdge": {
    "heading": "One clear vision. Smooth implementation.",
    "workflow": {
      "strategy": "Strategy",
      "design": "Design",
      "code": "Code",
      "content": "Content",
      "launch": "Launch"
    },
    "valueProposition": "Because I shoot the video and write the code, your website is designed around your story, not the other way around."
  },
  "socialProof": {
    "heading": "Trusted for 20 years",
    "recommendations": {
      "heading": "Recommendations"
    },
    "companies": [
      "2trde",
      "Testbirds",
      "GitDigest",
      "HireMeMate",
      "Polestar"
    ],
    "featuredProject": {
      "title": "Featured project",
      "projectTitle": "Polestar Partnership Launch",
      "description": "A complete campaign where I handled the branding, the website, and the video—all from one vision.",
      "cta": "View case study"
    }
  },
  "localPresence": {
    "heading": "High-End Quality, Locally Delivered",
    "copy": "Based in Timișoara, I provide Western-market quality with the benefit of local, face-to-face partnership. Whether it's a content day at your office in Arad or a UI workshop in the heart of Timișoara, I'm your on-call creative department."
  },
  "packages": {
    "heading": "Choose Your Path",
    "audit": {
      "title": "The Audit",
      "description": "Quick win for big companies. UI/UX audit and strategic recommendations.",
      "cta": "Learn More"
    },
    "launch": {
      "title": "The Launch",
      "description": "For new brands. Complete digital identity from concept to launch.",
      "cta": "Learn More"
    },
    "partnership": {
      "title": "The Partnership",
      "description": "Monthly content retainer. Ongoing support for growing businesses.",
      "cta": "Learn More"
    }
  },
  "footerCta": {
    "heading": "Ready to unify your digital presence?",
    "contactText": "Let's discuss your project",
    "bookSession": "Book a Strategy Session",
    "or": "or",
    "contactLink": "Get in touch"
  }
}
